import React from "react";
import { Layout as BaseLayout } from 'react-admin';
import { Menu } from './Menu';
import MyAppBar from "./MyAppBar";

export const Layout = (props) => <BaseLayout {...props} menu={Menu} appBar={MyAppBar} />;
